var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/placeholder/components/placeholder_status_content.tsx";
import React from 'react';
import { randomIntFromInterval, generateText } from '../utils';
/** Fake status content while data is loading. */
const PlaceholderStatusContent = ({
  minLength,
  maxLength
}) => {
  const length = randomIntFromInterval(maxLength, minLength);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-slate-200 dark:text-slate-700",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "break-words",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, generateText(length)));
};
export default PlaceholderStatusContent;